import React, { useMemo, useState } from "react";
import { Box, Container } from "@mui/material";
import BackgroundImageCst from "@components/BackgroundImageCst";
import HeroCst from "@components/HeroCst";
import BudgetsFormCst from "../BudgetsFormCst";
import { useFetchDetail, usePostDetail } from "@hooks/useFetchDetail";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "@components/Breadcrumb";
import { useTranslation } from "react-i18next";
import { ServicesURL } from "@utils/utilsApi";
import { PagesID } from "@utils/utilsConfigurations";
import { StatusEnum } from "@components/ModalConfirmsCst/types";
import ModalConfirmsCst from "@components/ModalConfirmsCst";
import AnimationFadeIn from "@components/AnimationFadeIn";

const AddBudgets: React.FC = () => {
  const { t } = useTranslation(["budgets-page"]);
  const { columns } = useFetchDetail(
    ServicesURL.budgets,
    undefined,
    PagesID["budget"],
  );

  const navigate = useNavigate();
  const [accounts] = useState([]);

  const [openToast, setOpenToast] = useState<{
    s: StatusEnum;
    message: string;
    description?: string;
  }>();

  const { trigger: triggerBudget } = usePostDetail(ServicesURL.postBudget);

  const onSubmit = async (inputForm: any) => {
    setOpenToast({ s: StatusEnum.LOADING, message: "loading" });
    const objToSend: any = {
      year: inputForm.year ? inputForm.year.$y.toString() : "",
      cost_center_id: Number(inputForm.cost_center) || null,
      account_id: Number(inputForm.account) || null,
      allocated_budget: Number(inputForm.allocated_budget) || null,
      forecast1: Number(inputForm.forecast1) || null,
      forecast2: Number(inputForm.forecast2) || null,
      forecast3: Number(inputForm.forecast3) || null,
      notes: inputForm.notes || null,
    };

    try {
      await triggerBudget(objToSend);
      setOpenToast({ s: StatusEnum.OK, message: "" });
    } catch (error) {
      setOpenToast(undefined);
      console.error(error);
    }
  };

  const getColumns = useMemo(() => {
    return columns.map((el) => {
      if (
        el.accessorKey === "spent_budget" ||
        el.accessorKey === "committed_budget"
      ) {
        return { ...el, type: "" };
      } else {
        return { ...el };
      }
    });
  }, [columns]);

  return (
    <AnimationFadeIn>
      <BackgroundImageCst
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-budget.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst
          title={t("add.hero-title")}
          description={t("add.hero-description")}
        />
        {columns && (
          <Box
            sx={{
              mt: "25px",
            }}
          >
            <BudgetsFormCst
              columns={getColumns}
              onSubmit={onSubmit}
              backButton={() => {
                navigate(-1);
              }}
              fullWidth={true}
              optionsSelect={accounts}
            />
          </Box>
        )}
      </Container>
      <ModalConfirmsCst
        open={!!openToast}
        title={t("hero-title-add")}
        description={""}
        onCallBackClosed={() => {
          setOpenToast(undefined);
        }}
        status={openToast}
      />
    </AnimationFadeIn>
  );
};

export default AddBudgets;
